import InfiniteScroll from "react-infinite-scroll-component";
import {
  List,
  ListItem,
  ListItemText,
  Typography,
  FormControl,
  Stack,
  InputAdornment,
  OutlinedInput,
  Box,
  Checkbox,
  ListItemIcon,
  ListItemButton,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect, useState } from "react";
import { Loader } from "./Loader";
import { useStoreSelectDialog } from "../hooks/useStoreSelectDialog";
import { CustomeDialog } from "./CustomeDialog";
import { StoreUpdateDialog } from "../../modules/Templates/components/StoreUpdateDialog";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import CloseIcon from "@mui/icons-material/Close";
import { arraySort } from "../../utils";
import CustomDialogFooter from "./CustomDialogFooter";

export const TemplateStoreSelectDialog = (props) => {
  const {
    onSelect,
    isSelected,
    disabled,
    onSubmit,
    isCheckIndeterminate,
    selectedStores,
    alreadySelectedStores,
    open,
    handleClickOpen,
    handleClose,
    templates,
    onChangeStoreEffectiveDate,
    setTemplates,
    assignedStoreState,
    id,
    assingedStoreListQueryTemplate,
  } = props;

  const {
    listQuery: { data, isLoading },
    state,
    HandleSearchFilter,
  } = useStoreSelectDialog();

  if (isLoading) {
    return <Loader />;
  }

  return (
    <>
      <Stack gap="8px" maxHeight="calc(90vh - 70px)" minHeight="400px">
        <Stack px="16px" pt="16px">
          <FormControl size="small" fullWidth={true}>
            <OutlinedInput
              placeholder="Search Store"
              size="small"
              value={state.search}
              startAdornment={
                <InputAdornment position="start">
                  <SearchIcon size="large" />
                </InputAdornment>
              }
              endAdornment={
                state.search && (
                  <InputAdornment
                    sx={{ cursor: "pointer" }}
                    onClick={(e) => {
                      HandleSearchFilter("initial", "");
                    }}
                    position="end"
                  >
                    <CloseIcon size="large" />
                  </InputAdornment>
                )
              }
              fullWidth
              onChange={(e) => {
                HandleSearchFilter("search", e.target.value);
              }}
            />
          </FormControl>
        </Stack>

        {data.length > 0 ? (
          <Box
            id="scrollableDiv"
            sx={{ height: "100%", overflow: "auto" }}
            fullWidth
          >
            <InfiniteScroll
              scrollableTarget="scrollableDiv"
              dataLength={data?.length}
              next={null}
              hasMore={null}
              loader={
                <Box sx={{ display: "flex", justifyContent: "center" }}>
                  Loading...
                </Box>
              }
            >
              <List sx={{ width: "100%", py: "2px" }}>
                {arraySort(data, "name").map((value) => {
                  // Sort stores alphabetically by name
                  const stores = Array.isArray(value?.stores)
                    ? arraySort(value?.stores, "name")
                    : [];

                  // Filter stores to only include those matching the search input
                  const filteredStores = stores.filter((store) =>
                    store.name
                      ?.toLowerCase()
                      ?.includes(state.search.toLowerCase()),
                  );

                  // If a search is active but no stores in this region match, skip rendering this region
                  if (state.search && filteredStores.length === 0) return null;

                  return (
                    <>
                      {stores && stores.length === 0 ? (
                        ""
                      ) : (
                        <ListOfState
                          key={value.id}
                          value={{ ...value, stores: filteredStores }}
                          labelId={`checkbox-list-label-${value.id}`}
                          onSelect={onSelect}
                          isSelected={isSelected}
                          isCheckIndeterminate={isCheckIndeterminate}
                          selectedStores={selectedStores}
                          alreadySelectedStores={alreadySelectedStores}
                          forceOpen={!!state.search}
                        />
                      )}
                    </>
                  );
                })}
              </List>
            </InfiniteScroll>
          </Box>
        ) : (
          <Stack
            height="400px"
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Typography
              component="span"
              variant="caption"
              color="text.secondary"
              fontWeight={400}
            >
              There is no stores found
            </Typography>
          </Stack>
        )}
      </Stack>
      <CustomDialogFooter
        disabled={disabled}
        handleClose={handleClose}
        onSubmit={() => handleClickOpen(true, id)}
      />

      {open === true && (
        <CustomeDialog
          PaperProps={{
            sx: {
              minWidth: "570px",
              minHeight: "280px",
              borderRadius: "10px",
            },
          }}
          open={open}
          // handleClose={handleClose}
          title={
            <Typography
              sx={{
                padding: "20px 20px 8px 20px",
                fontWeight: 500,
                fontSize: "20px",
                width: "100%",
              }}
            >
              From when should this template change be applied to generated
              production charts?
            </Typography>
          }
          content={
            <StoreUpdateDialog
              onSubmit={onSubmit}
              templates={templates}
              onChangeStoreEffectiveDate={onChangeStoreEffectiveDate}
              setTemplates={setTemplates}
              handleClose={() => {
                handleClickOpen(false, id);
                // handleClose()
              }}
              state={assignedStoreState}
              isDisabled={assingedStoreListQueryTemplate?.isPending}
            />
          }
        />
      )}
    </>
  );
};

function ListOfState({
  value,
  labelId,
  onSelect,
  selectedStores,
  alreadySelectedStores,
  forceOpen,
}) {
  const [open, setOpen] = useState(forceOpen);

  useEffect(() => {
    if (forceOpen) {
      setOpen(true);
    }
  }, [forceOpen]);

  const handleExpandClick = (e) => {
    e.stopPropagation();
    setOpen((prev) => !prev);
  };

  const isSelectedCheck = (value) => {
    if (value.stores) {
      const subArray = value?.stores?.map((e, i) => {
        return e.id;
      });
      const commonIDs1 = selectedStores.filter((val) => subArray.includes(val));
      return subArray.every((val) => commonIDs1.includes(val));
    } else {
      return isSelected(value.id);
    }
  };

  const isSelected = (id) => {
    if (selectedStores.includes(id)) {
      return true;
    } else {
      return selectedStores.includes(id);
    }
  };

  const isDisabled = (value) => {
    return alreadySelectedStores.includes(value);
  };

  const isDisable = (value) => {
    if (value.stores) {
      const subArray = value?.stores?.map((e, i) => {
        return e.id;
      });
      const commonIDs1 = selectedStores.map((val) => subArray.includes(val));
      return subArray.every((val) => commonIDs1.includes(val));
    } else {
      return selectedStores.includes(value.id);
    }
  };

  return (
    <>
      <ListItem key={value} dense>
        <ListItemButton
          role={undefined}
          dense
          sx={{
            borderRadius: "8px",
          }}
          selected={isSelectedCheck(value)}
        >
          <ListItemIcon
            sx={{
              minWidth: "32px",
            }}
          >
            <Checkbox
              edge="edge"
              disabled={isDisable(value)}
              checked={isSelectedCheck(value)}
              onChange={(e) => {
                onSelect(value, e);
                setOpen(true);
              }}
              disableRipple
              inputProps={{ "aria-labelledby": labelId }}
            />
          </ListItemIcon>
          <ListItemText
            id={labelId}
            primary={value.name}
            onClick={() => setOpen(!open)}
          />
          <ExpandMoreIcon
            sx={{
              color: "#999999",
              transform: open ? "rotate(180deg)" : "",
              transition: "transform 0.3s",
            }}
            onClick={handleExpandClick}
          />
        </ListItemButton>
      </ListItem>
      {open &&
        value.stores.map((v, index) => {
          const selected = isSelected(v.id);
          return (
            <ListItem key={index} dense>
              <ListItemButton
                role={undefined}
                dense
                sx={{ borderRadius: "8px" }}
                selected={selected}
              >
                <ListItemIcon
                  sx={{
                    minWidth: "32px",
                    marginLeft: "12px",
                  }}
                >
                  <Checkbox
                    edge="edge"
                    checked={selected}
                    disabled={isDisabled(v.id)}
                    onChange={() => onSelect(v)}
                    disableRipple
                  />
                </ListItemIcon>
                <ListItemText primary={v.name} />
              </ListItemButton>
            </ListItem>
          );
        })}
    </>
  );
}
